<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="rateBucketDetails" dataKey="rateBucketDetailId" (onEditInit)="onCellEditInit($event)" (onEditComplete)="onCellEditComplete($event)" (onEditCancel)="onCellEditCancel()" [lazy]="false"
  [totalRecords]="recordTotal" [paginator]="true" [rows]="rows" [showCurrentPageReport]="true" [(first)]="first" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [rowsPerPageOptions]="[10,50,100]" [loading]="formLoading" [responsive]="true" sortMode="multiple" [multiSortMeta]="multiSortMeta"
  [globalFilterFields]="['rateBucketId','rateBucketName','name','startDate','endDate','listPriceAdjustmentAmount','minimumPriceSetByManager','minimumPriceSetByOwner']" [scrollable]="false" scrollHeight="500px"
  [resizableColumns]="true" styleClass="rates-bucket-details p-datatable-striped" [style]="{'width':'100%'}">
  <ng-template pTemplate="caption">

    <table style="width:100%">
      <tr>
        <td style="white-space:nowrap;"><b>Rates</b></td>
        <td style="width:100%;text-align: right">
          <button mat-button style="color:green" (click)="onOpenFormAdd()">
            <mat-icon style="font-size:140%">add_circle</mat-icon> Add Rate
          </button>&nbsp;&nbsp;

          &nbsp;&nbsp;<button mat-button style="color:red" (click)="onResetFilter()">
          <mat-icon style="font-size:140%">filter_alt</mat-icon> Clear Filters
        </button>

        &nbsp;&nbsp;<button mat-button style="color:blue" (click)="bulkEdit()">
        <mat-icon style="font-size:140%">edit_road</mat-icon> Bulk Edit
      </button>

      &nbsp;&nbsp;<app-short-term-rental-select (reset)="resetFilters" (doSelectShortTermRental)="filterByShortTermRental($event)"></app-short-term-rental-select>&nbsp;&nbsp;

      <input pInputText type="text" (input)="pt.filterGlobal($event.target.value, 'contains')" placeholder="Search in rates" />

      <ng-template let-strSearchResults pTemplate="item">
        <div style="font-size:18px;float:right;margin:10px 10px 0 0">{{strSearchResults.propertyCode}} + ' ' + {{strSearchResults.locationId}}</div>
      </ng-template>
    </td>
  </tr>
</table>

</ng-template>
<ng-template pTemplate="header">
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">{{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
  <tr>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'rateBucketName', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'startDate', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'endDate', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'listPrice', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentAmount', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentPercent', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th>
      <input pInputText type="text" (input)="pt.filter($event.target.value, 'minimumPriceSetByManager', 'contains')" placeholder="" class="p-column-filter">
    </th>
    <th [ngStyle]="{'width': 'auto'}"></th>

  </tr>
</ng-template>
<ng-template pTemplate="body" let-rateBucketDetail>
  <tr>
    <td>{{rateBucketDetail.rateBucketName}} </td>
    <td [pEditableColumn]="rateBucketDetail" [pEditableColumnField]="'name'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <input pInputText type="text" [(ngModel)]="rateBucketDetail.name" [style]="{'background-color':'#FFFFFF'}">
        </ng-template>
        <ng-template pTemplate="output">
          {{rateBucketDetail.name}}
        </ng-template>
      </p-cellEditor>
    </td>
    <td [pEditableColumn]="rateBucketDetail" [pEditableColumnField]="'startDate'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <input pInputText type="text" [(ngModel)]="rateBucketDetail.startDate" required>
        </ng-template>
        <ng-template pTemplate="output">
          {{rateBucketDetail.startDate | date:'M-d-yy'}}
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="rateBucketDetail" [pEditableColumnField]="'endDate'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <input pInputText type="text" [(ngModel)]="rateBucketDetail.endDate" required>
        </ng-template>
        <ng-template pTemplate="output">
          {{rateBucketDetail.endDate | date:'M-d-yy'}}
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="rateBucketDetail" [pEditableColumnField]="'listPrice'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <input pInputText type="text" [(ngModel)]="rateBucketDetail.listPrice" required>
        </ng-template>
        <ng-template pTemplate="output">
          {{rateBucketDetail.listPrice | currency:'USD'}}
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="rateBucketDetail" [pEditableColumnField]="'listPriceAdjustmentAmount'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <input pInputText type="text" [(ngModel)]="rateBucketDetail.listPriceAdjustmentAmount" required>
        </ng-template>
        <ng-template pTemplate="output">
          {{rateBucketDetail.listPriceAdjustmentAmount | currency:'USD'}}
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="rateBucketDetail" [pEditableColumnField]="'listPriceAdjustmentPercent'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <input pInputText type="text" [(ngModel)]="rateBucketDetail.listPriceAdjustmentPercent" required>
        </ng-template>
        <ng-template pTemplate="output">
          {{rateBucketDetail.listPriceAdjustmentPercent |  percent}}
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="rateBucketDetail" [pEditableColumnField]="'minimumPriceSetByManager'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <input pInputText type="text" [(ngModel)]="rateBucketDetail.minimumPriceSetByManager" required>
        </ng-template>
        <ng-template pTemplate="output">
          {{rateBucketDetail.minimumPriceSetByManager | currency:'USD'}}
        </ng-template>
      </p-cellEditor>
    </td>


    <td>{{rateBucketDetail.lastUpdate | date:'M-d-yy' }} </td>

    <td><span style="float:none">
      <!--
      Row Editing Features
      <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="use-mat-icon-instead" (click)="onRowEditInit(rateBucketDetail)" class="p-button-rounded p-button-text">
        <mat-icon>edit</mat-icon>
      </button>
      <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(rateBucketDetail)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
      <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(rateBucketDetail, ri)" class="p-button-rounded p-button-text p-button-danger"></button> -->


      <a>
        <mat-icon style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(rateBucketDetail)">edit</mat-icon>
      </a>

      <!-- a>
      <mat-icon style="color:red; font-size:110%; padding-left:20px;" (click)="onRowDelete(rateBucketDetail)">delete</mat-icon>
    </a> -->
  </span>
</td>
</tr>
</ng-template>
</p-table>
